function accordion() {
    const countries = document.querySelectorAll(".international-participants h3");
    for (const country of countries) {
    // country.addEventListener('click', function(e) {
    //   country.nextElementSibling.classList.toggle("active");
    // });
    country.tabIndex = 0;
    country.nextElementSibling.tabIndex = 0;
    country.textContent = country.textContent.trim();
    }
}
export default accordion;


// WEBPACK FOOTER //
// ./src/js/partials/accordion.js